var renderCalendar = function() {
    var calendarOptions = {
        template: $('#calendarTemplate').html(),
        multiDayEvents: {
            endDate: 'end',
            singleDay: 'date',
            startDate: 'start'
        },
        clickEvents: {
            click: function(target) {
                if (target.events.length) {
                    var $calendar = $(target.element).closest('.rail-calendar');
                    var $information = $calendar.find('.day-information');
                    var activeClass  = 'active';

                    $information.find('.day-label').text(target.date.format('MMMM Do YYYY'));
                    $information.find('.details .event').hide();
                    $.each(target.events, function(key, event) {
                        $information.find('#' + event.eventId).show()
                    });

                    $information
                        .addClass(activeClass)
                        .find('.close-information')
                        .off('click')
                        .on('click', function() {
                            $information.removeClass(activeClass);
                        });
                }
            }
        }
    };
    var $currentMonth = $('.current-month');
    var $nextMonth = $('.next-month');

    var currentMonthOptions = $.extend({},
        calendarOptions,
        {
            startWithMonth: $currentMonth.data('month'),
            events: $currentMonth.data('events')
        }
    );
    $currentMonth.clndr(currentMonthOptions);

    var nextMonthOptions = $.extend({},
        calendarOptions,
        {
            startWithMonth: $nextMonth.data('month'),
            events: $nextMonth.data('events')
        }
    );
    $nextMonth.clndr(nextMonthOptions);
};

$(function(){
    'use strict';

    renderCalendar();

    var filterSubmit = function(e){
        if (e) {
            e.preventDefault();
        }

        var $eventType = $('#eventTypeSelector');
        var $month = $('#monthSelector');

        var path = $month.val();
        if ($eventType.val()) {
            path += '?eventType=' + $eventType.val();
        }
        path += '#events';

        var results = $('div#events');

        results.css('opacity', 0.3);

        if (window.history.replaceState) {
            window.history.replaceState(
                {}, document.title, path
            );
        }

        results.load(path + ' div#events>*', function(){
            results.css('opacity', 1);
            renderCalendar();
        });
    };

    var $cal = $('div.cal');
    $cal.on('change', '#eventTypeSelector,#monthSelector', function() {
        filterSubmit();
    });

    $cal.on('click', '.event-type a', function(e) {
        e.preventDefault();
        $('#eventTypeSelector').val($(this).data('event-type'));
        filterSubmit();
    });
});
